import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface SupportDashboardReporterOption {
  id: string;
  name: string;
  ticketCount: number;
}

@Component({
  selector: "app-support-dashboard-reporter-filter",
  templateUrl: "./support-dashboard-reporter-filter.component.html",
  styleUrls: ["./support-dashboard-reporter-filter.component.css"],
})
export class SupportDashboardReporterFilterComponent {
  @Input() reporterOptions: SupportDashboardReporterOption[] = [];
  @Input() loadingReporters = false;
  @Input() placeholder = "All Reporters";
  @Input() header = "Reporter";

  // Keep the binding pattern identical to the existing inline ng-select usage.
  @Input() selectedReporter = "";
  @Output() selectedReporterChange = new EventEmitter<string>();

  // Forward the ng-select change event to the parent (parent keeps the logic).
  @Output() reporterChange = new EventEmitter<unknown>();

  onSelectedReporterChange(value: string | null): void {
    this.selectedReporterChange.emit(typeof value === "string" ? value : "");
  }

  onReporterChange(value: unknown): void {
    this.reporterChange.emit(value);
  }
}
